import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  request,
  type V3ApiFailedResponse,
  type V3ApiSuccessfulResponse,
} from 'javascripts/services/v3ApiClient';
import type { ProjectDatabaseId } from 'data/v1';
import Steven from 'helpers/steven';

import { SHOWCASE_PROJECT_QUERY_KEY } from './useGetShowcaseProject';
import { SHOWCASE_PROJECT_MEDIA_QUERY_KEY } from './useGetShowcaseProjectMedia';

type DeleteShowcaseProjectResponse = V3ApiSuccessfulResponse<{
  message: string;
}>;

type UseDeleteShowcaseProjectArgs = {
  onError?: () => void;
  onSuccess?: () => void;
};

export const useDeleteShowcaseProject = ({
  onError,
  onSuccess,
}: UseDeleteShowcaseProjectArgs) => {
  const queryClient = useQueryClient();

  return useMutation<
    DeleteShowcaseProjectResponse,
    V3ApiFailedResponse,
    ProjectDatabaseId
  >({
    mutationFn: (projectDatabaseId) => {
      return request({
        url: `/projects/${projectDatabaseId}/showcase_project`,
        method: 'delete',
      });
    },
    onError,
    onSuccess: (_, projectDatabaseId) => {
      queryClient.invalidateQueries({
        queryKey: [SHOWCASE_PROJECT_QUERY_KEY, projectDatabaseId],
      });
      queryClient.invalidateQueries({
        queryKey: [SHOWCASE_PROJECT_MEDIA_QUERY_KEY, projectDatabaseId],
        refetchType: 'all',
      });
      Steven.entityCrud({
        entity_id: `${projectDatabaseId}`,
        entity_type: 'showcase_project',
        action: 'deleted',
      });

      onSuccess?.();
    },
  });
};
